import ReactGA4 from "react-ga4"

const InitializeAnalytics = () => {
  // Initialize GA4
  ReactGA4.initialize("G-Z3TNG42X7B")
  //console.log("GA Initialized")
}

function TrackAnalyticsEvent(name: string){
  //console.log("GA event:", name)
  // Send GA4 Event
  ReactGA4.event(name)
}

export default InitializeAnalytics
export { InitializeAnalytics, TrackAnalyticsEvent }